import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  },
  address: {
    textTransform: 'uppercase'
  },
  error: {
    color: theme.colors.red
  }
}));

export default useStyles;
